import { useTranslation } from "react-i18next";
import calcMeterPercent from "../helpers/calcMeterPercent";
import getAccountType, { AccountType } from "../helpers/getAccountType";
import parseFloatValue from "../helpers/parseFloatValue";
import PRODUCT_TYPE from "../const/productType";
import { useAccountSummary } from "../helpers/syfApiQueries";
var getRevolvingCreditData = function (_a) {
    var _b, _c, _d, _e;
    var accountSummaryData = _a.accountSummaryData, t = _a.t;
    var creditLimit = (_b = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.credit) === null || _b === void 0 ? void 0 : _b.creditLimit;
    var availableCredit = (_c = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.credit) === null || _c === void 0 ? void 0 : _c.availableCredit;
    var statementBalance = (_d = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.billing) === null || _d === void 0 ? void 0 : _d.statementBalance;
    var currentBalance = (_e = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.credit) === null || _e === void 0 ? void 0 : _e.currentBalance;
    return {
        primary: {
            creditLimit: parseFloatValue(creditLimit),
            label: t("grid.creditMeter"),
            percent: calcMeterPercent(parseFloatValue(creditLimit), parseFloatValue(currentBalance)),
        },
        secondary: [
            {
                label: t("grid.currentBalance"),
                value: currentBalance,
                type: "amount",
            },
            {
                label: t("grid.statementBalance"),
                value: statementBalance,
                type: "amount",
            },
            {
                label: t("grid.availableToSpend"),
                value: availableCredit,
                type: "amount",
            },
        ],
        hasMeter: true,
    };
};
var getLoanData = function (_a) {
    var _b, _c, _d, _e, _f;
    var accountSummaryData = _a.accountSummaryData, t = _a.t;
    var productType = (_b = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.product) === null || _b === void 0 ? void 0 : _b.type;
    var principalAmount = (_c = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.installment) === null || _c === void 0 ? void 0 : _c.principalAmount;
    var isLoanLegacy = productType === PRODUCT_TYPE.INSTALLMENT_LOAN;
    var endDate = (_d = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.installment) === null || _d === void 0 ? void 0 : _d.endDate;
    var currentBalance = (_e = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.credit) === null || _e === void 0 ? void 0 : _e.currentBalance;
    var totalMinimumPaymentDue = (_f = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.billing) === null || _f === void 0 ? void 0 : _f.totalMinimumPaymentDue;
    if (productType === PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED) {
        return {
            primary: {
                label: t("grid.totalDue"),
                value: totalMinimumPaymentDue,
                type: "amount",
                toolTipText: t("grid.totalDueTooltip"),
            },
            secondary: {
                label: t("grid.loanMaturityDate"),
                value: endDate,
                type: "date",
            },
            hasMeter: false,
        };
    }
    return {
        primary: {
            label: isLoanLegacy ? t("grid.loanAmount") : t("grid.amountFinanced"),
            value: principalAmount,
            type: "amount",
        },
        secondary: {
            label: t("grid.totalLoanBalance"),
            value: currentBalance,
            toolTipText: t("grid.totalLoanBalanceTooltip"),
            type: "amount",
        },
        hasMeter: false,
    };
};
var useFeaturedContentData = function () {
    var _a;
    var accountSummaryData = useAccountSummary().data;
    var t = useTranslation().t;
    var productType = (_a = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.product) === null || _a === void 0 ? void 0 : _a.type;
    if (!productType) {
        return {};
    }
    switch (getAccountType(productType)) {
        case AccountType.PAY_IN_4:
        case AccountType.LOAN:
        case AccountType.LOAN_LEGACY:
        case AccountType.SECURED_INSTALLMENT_LOAN:
            return getLoanData({ accountSummaryData: accountSummaryData, t: t });
        case AccountType.CARD:
            return getRevolvingCreditData({ accountSummaryData: accountSummaryData, t: t });
        /* istanbul ignore next */
        default:
            throw new Error("Unknown product type");
    }
};
export default useFeaturedContentData;
//# sourceMappingURL=useFeaturedContentData.js.map